import { createSelector } from 'reselect'
import { sortByKeyInsensitive } from 'util/arrays'
import {
  selectMailboxesById,
  selectKnownMailboxes,
} from 'selectors/mailboxes_base'
import { selectTicketDraft } from './drafts'

const selectDraftMailboxBuilder = createSelector(
  selectMailboxesById,
  selectKnownMailboxes,
  (byId, known) => {
    return draft =>
      draft && draft.mailboxId ? byId[draft.mailboxId] : known[0]
  }
)

export const selectDraftMailbox = createSelector(
  selectTicketDraft,
  selectDraftMailboxBuilder,
  (draft, builder) => builder(draft)
)

export const selectPossibleDraftMailboxes = createSelector(
  selectDraftMailbox,
  selectKnownMailboxes,
  (draftMailbox, known) => {
    const filtered = draftMailbox
      ? known.filter(mailbox => mailbox.id != draftMailbox.id) // exclude draft mailbox
      : known
    return sortByKeyInsensitive(filtered, 'label')
  }
)
